export const firebaseConfigration = {
  apiKey: "AIzaSyA6QOR8u9WgYT8B_AjwvKB7dI54RKYa2V0",
  authDomain: "crossfitproduct.firebaseapp.com",
  projectId: "crossfitproduct",
  storageBucket: "crossfitproduct.appspot.com",
  messagingSenderId: "532567667163",
  appId: "1:532567667163:web:fd85b546bc28240c8af7fe",
  measurementId: "G-TW3KJY7993",
};
